// Per-prompt token grain → token MetaRow label + tooltip (O-2021).
//
// The EDGE_TYPE_PROMPT_HAS_TOKENS collapse is grain-aware: it returns this
// prompt's tokens at the session's FINEST available grain and reports which
// grain answered ("turn" | "submission" | "session" | "user_day"). The label
// tells an analyst whether the number is THIS prompt's own cost (summable) or a
// shared rollup they must NOT sum N× across the turn/session/day:
//
//   turn       → this prompt's OWN tokens (per-prompt, exact). Summable.
//   submission → the whole TRACE total, shared by every prompt in the turn.
//   session    → the session total, shared across the session's prompts.
//   user_day   → the per-user daily total, shared.
//
// Pure — lives in its own module (not inside ContextPanel.jsx) so it's unit-
// testable without dragging in the component's window-touching import chain.
export function tokenGrainMeta(grain) {
  switch (grain) {
    case "turn":
      return {
        label: "Prompt",
        title: "Tokens for THIS prompt's request (per-prompt, finest grain). Summable across prompts.",
      };
    case "submission":
      return {
        label: "Trace",
        title: "Total tokens for this prompt's entire trace — every API call in the agentic turn. The same trace total shows on each prompt in the turn, so don't sum across prompts.",
      };
    case "session":
      return {
        label: "Session",
        title: "Session-level token total (the finest grain captured for this session). Shared across the session's prompts — don't sum.",
      };
    case "user_day":
      return {
        label: "Today",
        title: "Per-user daily token total (the finest grain available). Shared — don't sum.",
      };
    default:
      return {
        label: "Tokens",
        title: "Token total at the finest grain captured.",
      };
  }
}
